import { Box, TextField } from "@mui/material";
import { useState } from "react";
import { IoSearchOutline } from "react-icons/io5";
import PropTypes from "prop-types"; // Optional: for better dev experience

export const SearchBar = ({ searchQuery = "", setSearchQuery = () => {}, placeholder = "Search" }) => {
  const [openSearch, setOpenSearch] = useState(false);

  const handleBlur = () => {
    if (!searchQuery) setOpenSearch(false);
  };

  // Guard against non-function setSearchQuery (logs a warning in console for debugging)
  const handleChange = (e) => {
    if (typeof setSearchQuery !== "function") {
      console.warn("SearchBar: setSearchQuery prop must be a function");
      return;
    }
    setSearchQuery(e.target.value);
  };

  return (
    <Box
      sx={{
        width: openSearch ? "350px" : "auto",
        display: "flex",
        gap: "6px",
        border: "2px solid #eaeaea !important",
        borderRadius: "20px",
        alignItems: "center",
        transition: "all 0.3s",
        paddingRight: openSearch ? "4px" : 0,
      }}
    >
      {openSearch ? (
        <TextField
          sx={{
            width: "100%",
            border: "none !important",
            marginLeft: "12px",
            "& input": {
              border: "none !important",
              fontSize: "18px",
              marginTop: "3px",
              boxShadow: "none",
            },
          }}
          variant="standard"
          slotProps={{
            input: {
              disableUnderline: true,
            },
          }}
          size="small"
          name="q"
          placeholder={placeholder}
          value={searchQuery}
          onChange={handleChange} // Use the guarded handler
          onBlur={handleBlur}
        />
      ) : (
        <></>
      )}
      <Box
        width={"40px"}
        height={"40px"}
        sx={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={() => setOpenSearch(!openSearch)}
      >
        <IoSearchOutline size={24} color="#8a8a8e" />
      </Box>
    </Box>
  );
};

// Optional PropTypes for better error messages in dev tools
SearchBar.propTypes = {
  searchQuery: PropTypes.string,
  setSearchQuery: PropTypes.func,
  placeholder: PropTypes.string,
};